import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ApiClientService } from '../../core/api/api-client.service';
import { AuthService } from '../../core/auth/auth.service';
import { CertificateStatus, CertificateSummary, PageResponse } from '../../core/models/portal.models';

@Component({
  selector: 'app-certificates-page',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './certificates-page.component.html'
})
export class CertificatesPageComponent implements OnInit {
  private readonly api = inject(ApiClientService);
  private readonly auth = inject(AuthService);

  protected readonly superAdmin = computed(() => this.auth.hasAnyRole(['SUPER_ADMIN']));
  protected readonly certificates = signal<PageResponse<CertificateSummary> | null>(null);
  protected readonly summary = computed(() => {
    const items = this.certificates()?.items ?? [];
    return {
      total: this.certificates()?.total ?? 0,
      valid: items.filter((certificate) => certificate.status === 'VALID').length,
      issued: items.filter((certificate) => certificate.status === 'ISSUED').length,
      expired: items.filter((certificate) => certificate.status === 'EXPIRED').length
    };
  });

  ngOnInit(): void {
    this.api.certificates().subscribe((certificates) => this.certificates.set(certificates));
  }

  protected formatDate(value: string | null): string {
    if (!value) {
      return '-';
    }

    return new Intl.DateTimeFormat('de-DE', { dateStyle: 'short' }).format(new Date(value));
  }

  protected statusLabel(status: CertificateStatus): string {
    const labels: Record<CertificateStatus, string> = {
      ISSUED: 'Ausgestellt',
      VALID: 'Gültig',
      EXPIRED: 'Abgelaufen',
      REVOKED: 'Widerrufen'
    };

    return labels[status] ?? status;
  }
}
